import MuiLinearProgress, { LinearProgressProps } from '@mui/material/LinearProgress';

export type { LinearProgressProps };

export const LinearProgress = (props: LinearProgressProps) => <MuiLinearProgress {...props} />;
